export const getters = {
  appNavItems: (state) => state.appNavItems,
  has_credit_note: (state) => state.has_credit_note,
  mainNavActive: (state) => state.mainNavActive,
  appDrawer: (state) => state.appDrawer,
  loginUser: (state) => state.loginUser,
  is_loaded_home_page_data: (state) => state.is_loaded_home_page_data,
  is_loaded_royalty_page_data: (state) => state.is_loaded_royalty_page_data,
  resetPassword: (state) => state.resetPassword,
  loginRedirectRoute: state => state.loginRedirectRoute,
  activeRouteItem: state => state.activeRouteItem,
  activeSubRouteItem: state => state.activeSubRouteItem,
  royalties: state => state.royalties,
  userDetails: state => state.userDetails,
  userInfo: state => state.userInfo,
  languages: state => state.languages,
  isResetPassword: state => state.isResetPassword,
  user: state => state.user,
  redirectRoute: state => state.redirectRoute,
  showCloseIcon: state => state.showCloseIcon,
  period_report_data: state => state.chartReport?.period_report_data,
  channel_report_data: state => state.chartReport?.channel_report_data,
  default_currency: state => state.chartReport?.default_currency,
  release_report_data: state => state.chartReport?.release_report_data,
  report_keys: state => state.chartReport?.report_keys,
  latest_statements: state => state.chartReport?.latest_statements,
  top_release_report_data: state => state.chartReport?.top_release_report_data,
  top_tracks_report_data: state => state.chartReport?.top_tracks_report_data,
  b2b_message_area: state => state.chartReport?.b2b_message_area,
  display_name: state => state.chartReport?.client?.display_name,
  report_country_digital: state => state.royaltyChartReport?.report_country_digital,
  report_shop_digital: state => state.royaltyChartReport?.report_shop_digital,
  report_country_physical: state => state.royaltyChartReport?.report_country_physical,
  report_release: state => state.royaltyChartReport?.report_release,
  report_channel: state => state.royaltyChartReport?.report_channel,
  is_loaded_channel_data: state => state.is_loaded_channel_data

}
